import type { Condition } from '@/types/automationSteps.ts';

export const conditionalBranchLabel = (condition: Condition, index: number): string =>
  `Branch: ${condition.name || `Condition ${index + 1}`}${condition.is_disabled ? ' (Disabled)' : ''}`;
